import {FC} from 'react';
import {
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterLink,
} from '@ionic/react';
import {useLocation} from 'react-router-dom';
import {FiFile, FiSettings, FiFileText, FiHome} from 'react-icons/fi';
import UILogo from '../UICommon/UILogo';

import './AppLayoutMenu.css';

interface AppLayoutMenuPage {
  url: string;
  title: string;
  icon: any;
}

const appPages: AppLayoutMenuPage[] = [
  {
    title: 'Hem',
    url: '/home',
    icon: <FiHome className='text-2xl'/>,
  },
  {
    title: 'Deklaration',
    url: '/fargdeklaration',
    icon: <FiFile className='text-2xl'/>,
  },
  {
    title: 'Egna frågor',
    url: '/egen-deklaration',
    icon: <FiFileText className='text-2xl'/>,
  },
  {
    title: 'Inställningar',
    url: '/installningar',
    icon: <FiSettings className='text-2xl'/>,
  },
];

type AppLayoutMenuProps = {
  style?: string;
  side?: 'start' | 'end';
}

const AppLayoutMenu: FC<AppLayoutMenuProps> = ({style, side}) => {
  const location = useLocation();

  return (
    <IonMenu contentId="main" type="overlay" className={`${style} backdrop-blur-2`} swipe-gesture={true} side={side}>
      <div className='h-full shadow-l relative'>
        <IonList id="inbox-list" className='flex flex-col overflow-y-auto
         space-y-5 items-center pt-8 pb-20 h-full bg-gray-menu'>
          <IonRouterLink routerLink='/home' className='py-5 w-[60%]'>
            <UILogo style='text-right text-sm leading-2'/>
          </IonRouterLink>
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false} className="w-full flex justify-center">
                <IonRouterLink
                  className={`${location.pathname.startsWith(appPage.url) ? 'selected' : 'text-black-ink'} ` +
                  ' bg-white flex flex-row justify-center shadow-menu w-[60%] py-5 rounded-md'}
                  routerLink={appPage.url}
                  routerDirection="none">
                  <div className='flex justify-center items-center mb-2'>{appPage.icon}</div>
                  <label className='text-sm'>{appPage.title}</label>
                </IonRouterLink>
              </IonMenuToggle>
            );
          })}
        </IonList>
      </div>
    </IonMenu>
  );
};

export default AppLayoutMenu;
